import React from "react";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "../../../../app/hooks";
import { BackButton } from "../../../../components";
import { DailyReportOrder } from "../../../../models";

export const DailyReportDriverOrdersView: React.FC = () => {
  const navigate = useNavigate();

  const ordersToShow = useAppSelector(
    (state) => state.reports.dailyReportOrdersToShow
  );
  const dailyReportOrders = useAppSelector(
    (state) => state.reports.dailyDriverReport?.orders || []
  );
  const drivers = useAppSelector((state) => state.driversV2.drivers);

  const orders: DailyReportOrder[] = [];
  ordersToShow.forEach((id) => {
    const result = dailyReportOrders.find((o) => o.id === id);

    if (!!result) {
      orders.push(result);
    }
  });

  const onBackButtonClick = () => {
    navigate(-1);
  };

  const onViewOrderButtonClick = (orderId: string) => () => {
    navigate(`/orders/${orderId}`);
  };

  const renderOrder = (order: DailyReportOrder): React.ReactNode => {
    const driver = drivers.find((d) => d.userId === order.driverId);

    return (
      <div className="order-container" key={order.id}>
        <div className="item-container">
          <div className="label">Customer:</div>
          <div className="value">{order.customerName}</div>
        </div>

        <div className="item-container">
          <div className="label">Address:</div>
          <div className="value">{order.address}</div>
        </div>

        <div className="item-container">
          <div className="label">Driver:</div>
          {driver && (
            <div className="value">{driver.name}</div>
          )}
        </div>

        <div className="item-container">
          <div className="label">Payment Type:</div>
          {order.paymentType && (
            <div className="value">{order.paymentType}</div>
          )}
        </div>

        <div
          className="view-order-button"
          onClick={onViewOrderButtonClick(order.id)}
        >
          View Order
        </div>
      </div>
    );
  };

  return (
    <div className="daily-report-orders-view-component">
      <BackButton onClick={onBackButtonClick} />

      <div className="title-container">
        <div className="title-row">
          <div className="title-text">Daily Report Driver Orders</div>
        </div>
      </div>

      {orders.map(renderOrder)}
    </div>
  );
};
